import { formatCurrency } from '@amzn/sss-website-theme';

/**
 * Calculates the bundle quantity by dividing the regular quantity by the bundle factor.
 * Uses Math.ceil to round up to ensure you get enough bundles to cover the requested quantity.
 *
 * @param quantity - The base quantity of credits
 * @param bundleFactor - The bundle factor (how many credits per bundle)
 * @returns Number of bundles needed, or 0 if bundleFactor is invalid
 */
export const calculateBundleQuantity = (quantity: number, bundleFactor?: number): number => {
  if (!bundleFactor || bundleFactor <= 0) {
    return 0;
  }
  return Math.ceil(quantity / bundleFactor);
};

/**
 * Calculates and formats the order total based on quantity and unit price.
 * Components should handle bundle logic and pass appropriate values.
 *
 * @param quantity - The quantity (can be adjusted for bundles by caller)
 * @param unitPrice - The unit price
 * @returns Formatted currency string (e.g., "$200.00")
 */
export const getFormattedOrderTotal = (quantity: number, unitPrice: number, currencyCode?: string): string => {
  const orderTotalCalculation = quantity * unitPrice;
  return formatCurrency(orderTotalCalculation, currencyCode);
};
